/**
 * @generated SignedSource<<b5600349f901376ef9a30ccaa015f6b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubInvoiceModelStatusChoices = "CANCELLED" | "DRAFT" | "OVERPAID" | "PAID" | "PENDING" | "REFUND" | "SENT" | "%future added value";
export type PianofunclubLessonStageModelLessonTypeChoices = "GROUP" | "INDIVIDUAL" | "PAIRED" | "%future added value";
export type PianofunclubLineItemModelItemTypeChoices = "ACCOUNT_OTHER_FEE_OR_DISCOUNT" | "BLOCK_OTHER_FEE_OR_DISCOUNT" | "EXAM_FEE" | "INSTRUMENT_DEPOSIT" | "LESSONS" | "MISSED_LESSON_DISCOUNT" | "%future added value";
export type PianofunclubPaymentModelPaymentTypeChoices = "BANK_TRANSFER" | "CASH" | "CREDIT_DEBIT_CARD" | "PAYPAL" | "%future added value";
export type LoadInvoiceQuery$variables = {
  block?: number | null | undefined;
  invoiceId?: string | null | undefined;
  profileId?: string | null | undefined;
  skip: boolean;
  startingYear?: number | null | undefined;
};
export type LoadInvoiceQuery$data = {
  readonly accountFeeOrCredit?: {
    readonly amount: number | null | undefined;
    readonly id: string;
  } | null | undefined;
  readonly invoice?: {
    readonly amountPaid: number | null | undefined;
    readonly assignedTo: {
      readonly accountNumber: string | null | undefined;
      readonly id: string;
      readonly user: {
        readonly email: string;
        readonly firstName: string;
        readonly id: string;
        readonly lastName: string;
      };
    } | null | undefined;
    readonly assignedToAccountNumber: string | null | undefined;
    readonly assignedToEmail: string | null | undefined;
    readonly assignedToFullName: string | null | undefined;
    readonly assignedToPhoneNumber: string | null | undefined;
    readonly block: number | null | undefined;
    readonly createdBy: {
      readonly user: {
        readonly email: string;
        readonly firstName: string;
        readonly id: string;
        readonly lastName: string;
      };
    } | null | undefined;
    readonly createdOn: string;
    readonly id: string;
    readonly initialSentTimestamp: string | null | undefined;
    readonly invoiceEmailSubject: string | null | undefined;
    readonly invoiceMessageString: string | null | undefined;
    readonly invoiceNumber: string;
    readonly invoicePdfSignedUrl: string | null | undefined;
    readonly isUpdate: boolean | null | undefined;
    readonly lastModified: string;
    readonly lessonBlocks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly examFee: number;
          readonly id: string;
          readonly instrument: {
            readonly name: string | null | undefined;
          } | null | undefined;
          readonly lessonStage: {
            readonly costPerLesson: number | null | undefined;
            readonly lessonDuration: number | null | undefined;
            readonly lessonType: PianofunclubLessonStageModelLessonTypeChoices;
          } | null | undefined;
          readonly lessons: {
            readonly totalCount: number | null | undefined;
          };
          readonly pupil: {
            readonly id: string;
            readonly user: {
              readonly firstName: string;
              readonly lastName: string;
            };
          } | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    };
    readonly lineItems: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly instrumentDescription: string | null | undefined;
          readonly itemType: PianofunclubLineItemModelItemTypeChoices;
          readonly pupil: {
            readonly id: string;
          } | null | undefined;
          readonly pupilDescription: string | null | undefined;
          readonly pupilDescriptionId: number | null | undefined;
          readonly quantity: number | null | undefined;
          readonly timePeriodDescription: string | null | undefined;
          readonly typeDescription: string | null | undefined;
          readonly unitAmount: number | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    };
    readonly notes: string | null | undefined;
    readonly otherInvoicesForBlock: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly createdOn: string;
          readonly id: string;
          readonly invoiceNumber: string;
          readonly status: PianofunclubInvoiceModelStatusChoices;
          readonly totalAmount: number | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    };
    readonly payments: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly amount: number | null | undefined;
          readonly id: string;
          readonly paymentDate: string | null | undefined;
          readonly paymentNote: string | null | undefined;
          readonly paymentReference: string | null | undefined;
          readonly paymentType: PianofunclubPaymentModelPaymentTypeChoices;
        } | null | undefined;
      } | null | undefined>;
    };
    readonly reminder1SentTimestamp: string | null | undefined;
    readonly reminder2SentTimestamp: string | null | undefined;
    readonly reminder3SentTimestamp: string | null | undefined;
    readonly staffNotes: string | null | undefined;
    readonly startingYear: number | null | undefined;
    readonly status: PianofunclubInvoiceModelStatusChoices;
    readonly totalAmount: number | null | undefined;
  } | null | undefined;
};
export type LoadInvoiceQuery = {
  response: LoadInvoiceQuery$data;
  variables: LoadInvoiceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "block"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "invoiceId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "profileId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startingYear"
},
v5 = {
  "kind": "Variable",
  "name": "block",
  "variableName": "block"
},
v6 = {
  "kind": "Variable",
  "name": "profileId",
  "variableName": "profileId"
},
v7 = {
  "kind": "Variable",
  "name": "startingYear",
  "variableName": "startingYear"
},
v8 = [
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "invoiceId",
    "variableName": "invoiceId"
  },
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNumber",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOn",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastModified",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAmount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUpdate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountPaid",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "staffNotes",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startingYear",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "block",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedToFullName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedToEmail",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedToPhoneNumber",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedToAccountNumber",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceEmailSubject",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceMessageString",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoicePdfSignedUrl",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initialSentTimestamp",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reminder1SentTimestamp",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reminder2SentTimestamp",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reminder3SentTimestamp",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "DjangoUserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    (v32/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "ProfileNode",
  "kind": "LinkedField",
  "name": "assignedTo",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountNumber",
      "storageKey": null
    },
    (v34/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "LineItemNodeConnection",
  "kind": "LinkedField",
  "name": "lineItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LineItemNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LineItemNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "itemType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quantity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unitAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timePeriodDescription",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pupilDescription",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pupilDescriptionId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "instrumentDescription",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "typeDescription",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfileNode",
              "kind": "LinkedField",
              "name": "pupil",
              "plural": false,
              "selections": [
                (v9/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v36/*: any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "PaymentNodeConnection",
  "kind": "LinkedField",
  "name": "payments",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaymentNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v38/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paymentType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paymentReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paymentDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paymentNote",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v36/*: any*/)
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "InvoiceNodeConnection",
  "kind": "LinkedField",
  "name": "otherInvoicesForBlock",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InvoiceNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InvoiceNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            (v16/*: any*/),
            (v13/*: any*/),
            (v11/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v36/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonNodeConnection",
  "kind": "LinkedField",
  "name": "lessons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "examFee",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lessonType",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lessonDuration",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "costPerLesson",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": [
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "concreteType": "AccountFeeOrCreditNode",
  "kind": "LinkedField",
  "name": "accountFeeOrCredit",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v38/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LoadInvoiceQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "InvoiceNode",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": [
                  (v34/*: any*/)
                ],
                "storageKey": null
              },
              (v37/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LessonBlockNodeConnection",
                "kind": "LinkedField",
                "name": "lessonBlocks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LessonBlockNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LessonBlockNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InstrumentNode",
                            "kind": "LinkedField",
                            "name": "instrument",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileNode",
                            "kind": "LinkedField",
                            "name": "pupil",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DjangoUserNode",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v42/*: any*/),
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LessonStageNode",
                            "kind": "LinkedField",
                            "name": "lessonStage",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v47/*: any*/)
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "LoadInvoiceQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "InvoiceNode",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": [
                  (v34/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v37/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LessonBlockNodeConnection",
                "kind": "LinkedField",
                "name": "lessonBlocks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LessonBlockNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LessonBlockNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InstrumentNode",
                            "kind": "LinkedField",
                            "name": "instrument",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileNode",
                            "kind": "LinkedField",
                            "name": "pupil",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DjangoUserNode",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v42/*: any*/),
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LessonStageNode",
                            "kind": "LinkedField",
                            "name": "lessonStage",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v47/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "6b1087b692ff96b6290dc160b8796a91",
    "id": null,
    "metadata": {},
    "name": "LoadInvoiceQuery",
    "operationKind": "query",
    "text": "query LoadInvoiceQuery(\n  $invoiceId: ID\n  $profileId: ID\n  $startingYear: Int\n  $block: Int\n  $skip: Boolean!\n) {\n  invoice(invoiceId: $invoiceId, profileId: $profileId, startingYear: $startingYear, block: $block) @skip(if: $skip) {\n    id\n    invoiceNumber\n    createdOn\n    lastModified\n    totalAmount\n    isUpdate\n    amountPaid\n    status\n    notes\n    staffNotes\n    startingYear\n    block\n    assignedToFullName\n    assignedToEmail\n    assignedToPhoneNumber\n    assignedToAccountNumber\n    invoiceEmailSubject\n    invoiceMessageString\n    invoicePdfSignedUrl\n    initialSentTimestamp\n    reminder1SentTimestamp\n    reminder2SentTimestamp\n    reminder3SentTimestamp\n    assignedTo {\n      id\n      accountNumber\n      user {\n        id\n        email\n        firstName\n        lastName\n      }\n    }\n    createdBy {\n      user {\n        id\n        email\n        firstName\n        lastName\n      }\n      id\n    }\n    lineItems {\n      edges {\n        node {\n          id\n          itemType\n          quantity\n          unitAmount\n          timePeriodDescription\n          pupilDescription\n          pupilDescriptionId\n          instrumentDescription\n          typeDescription\n          pupil {\n            id\n          }\n        }\n      }\n    }\n    payments {\n      edges {\n        node {\n          id\n          amount\n          paymentType\n          paymentReference\n          paymentDate\n          paymentNote\n        }\n      }\n    }\n    otherInvoicesForBlock {\n      edges {\n        node {\n          id\n          invoiceNumber\n          status\n          totalAmount\n          createdOn\n        }\n      }\n    }\n    lessonBlocks {\n      edges {\n        node {\n          id\n          instrument {\n            name\n            id\n          }\n          pupil {\n            id\n            user {\n              firstName\n              lastName\n              id\n            }\n          }\n          lessons {\n            totalCount\n          }\n          examFee\n          lessonStage {\n            lessonType\n            lessonDuration\n            costPerLesson\n            id\n          }\n        }\n      }\n    }\n  }\n  accountFeeOrCredit(profileId: $profileId, startingYear: $startingYear, block: $block) @skip(if: $skip) {\n    id\n    amount\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ac43f5f3f1597b3b8630b5f346bad44";

export default node;
